export class UserEntityModel {
    constructor(data) {
        this.id = data.id;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.userId = data.userId;
        this.entityId = data.entityId;
    }
}